import { render } from "./LanguageButtonComp.vue?vue&type=template&id=d24871e6"
import script from "./LanguageButtonComp.vue?vue&type=script&lang=js"
export * from "./LanguageButtonComp.vue?vue&type=script&lang=js"

import "./LanguageButtonComp.vue?vue&type=style&index=0&id=d24871e6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__